// extracted by mini-css-extract-plugin
module.exports = {"header":"OfferNegotiationTitle_header_1iqbF","date":"OfferNegotiationTitle_date_9eU4V","meta":"OfferNegotiationTitle_meta_1yaGD"};